(function () {
  const initIndexLoop = () => {
    const viewRoot = document.querySelector('[data-view]');
    const buttons = document.querySelectorAll('[data-view-toggle]');
    if (!viewRoot || buttons.length === 0) return;

    const applyView = (view) => {
      viewRoot.dataset.currentView = view;

      if (view === 'list') {
        viewRoot.classList.remove('lg:grid-cols-3');
        viewRoot.classList.add('grid-cols-1', 'gap-6');

        viewRoot.querySelectorAll('[data-view-card]').forEach((card) => {
          card.classList.remove('flex-col');
          card.classList.add('flex-row');

          const image = card.querySelector('[data-view-media]');
          if (image) {
            image.classList.remove('aspect-[16/10]', 'w-full');
            image.classList.add('w-64', 'shrink-0');
          }

          const body = card.querySelector('[data-view-body]');
          if (body) {
            body.classList.remove('pt-5');
            body.classList.add('pt-6');
          }
        });
      } else {
        viewRoot.classList.add('lg:grid-cols-3');
        viewRoot.classList.remove('grid-cols-1', 'gap-6');

        viewRoot.querySelectorAll('[data-view-card]').forEach((card) => {
          card.classList.add('flex-col');
          card.classList.remove('flex-row');

          const image = card.querySelector('[data-view-media]');
          if (image) {
            image.classList.add('aspect-[16/10]', 'w-full');
            image.classList.remove('w-64', 'shrink-0');
          }

          const body = card.querySelector('[data-view-body]');
          if (body) {
            body.classList.add('pt-5');
            body.classList.remove('pt-6');
          }
        });
      }

      buttons.forEach((btn) => {
        const isActive = btn.getAttribute('data-view-toggle') === view;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('text-gray-900', isActive);
        btn.classList.toggle('text-gray-500', !isActive);
        btn.classList.toggle('bg-gray-100', isActive);
      });
    };

    let stored = 'grid';
    try {
      stored = window.localStorage.getItem('blogView') || 'grid';
    } catch (_error) {
      stored = 'grid';
    }
    applyView(stored);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.getAttribute('data-view-toggle');
        if (!view) return;
        try {
          window.localStorage.setItem('blogView', view);
        } catch (_error) {
          // ignore localStorage write issues
        }
        applyView(view);
      });
    });

    const pagination = document.querySelector('[data-pagination]');
    const status = document.querySelector('[data-infinite-status]');
    if (!pagination) return;

    const getNextUrl = (root) => {
      const nextLink = root.querySelector('.page-numbers.next');
      return nextLink ? nextLink.getAttribute('href') : null;
    };

    let nextUrl = getNextUrl(document);
    if (!nextUrl) return;

    const sentinel = document.createElement('div');
    sentinel.className = 'h-8';
    pagination.insertAdjacentElement('afterend', sentinel);
    pagination.classList.add('hidden');

    const observer = new IntersectionObserver(
      async (entries) => {
        const entry = entries[0];
        if (!entry.isIntersecting || !nextUrl) return;

        if (status) status.classList.remove('hidden');
        const url = nextUrl;
        nextUrl = null;

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Failed to load');

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newPosts = doc.querySelectorAll('[data-posts] > article');
          newPosts.forEach((post) => {
            viewRoot.appendChild(post);
          });

          const currentView = viewRoot.dataset.currentView || 'grid';
          applyView(currentView);

          nextUrl = getNextUrl(doc);
          if (!nextUrl) observer.disconnect();
        } catch (_error) {
          observer.disconnect();
        } finally {
          if (status) status.classList.add('hidden');
        }
      },
      {
        rootMargin: '200px',
      }
    );

    observer.observe(sentinel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIndexLoop);
  } else {
    initIndexLoop();
  }
})();
